import i18n from "@/lang";

// 语言列表
export const languageList = [
    {
        value: "zh_CN",
        label: "简体中文",
    },
    {
        value: "en_US",
        label: "English",
    },
    {
        value: "ru_RU",
        label: "Pусский",
    },
];

// 设备类型
export const uavType = {
    MC: "MC/FW/HC/SIM", // 多旋翼/固定翼/无人直升机/模拟无人机
    VTL: "VTL", // 垂起固定翼
};

//航点模式
export const routeSpotMode = [
    {
        name: "普通",
        label: "normal",
        value: 4,
    },
    {
        name: "悬停",
        label: "hover",
        value: 5,
    },
];

// 完成动作
export const endAction_VTL = [
    {
        name: "降落",
        label: "land",
        value: 3,
    },
    {
        name: "归航",
        label: "returnHome",
        value: 21,
    },
];
export const endAction = [
    ...endAction_VTL,
    {
        name: "返航",
        label: "returnStarting",
        value: 9,
    },
    {
        name: "悬停",
        label: "hover",
        value: 5,
    },
];

// 超时动作
export const timeoutAction = [
    {
        name: "降落",
        label: "land",
        value: 3,
    },
    {
        name: "返航",
        label: "returnStarting",
        value: 9,
    },
];

/* 风级 */
export const windSpeedControl = function (value) {
    let speed = "";
    if (value < 0.3) {
        speed = 0; // (${value}m/s)
    } else if (value >= 0.3 && value < 1.6) {
        speed = 1;
    } else if (value >= 1.6 && value < 3.4) {
        speed = 2;
    } else if (value >= 3.4 && value < 5.5) {
        speed = 3;
    } else if (value >= 5.5 && value < 8.0) {
        speed = 4;
    } else if (value >= 8.0 && value < 10.8) {
        speed = 5;
    } else if (value >= 10.8 && value < 13.9) {
        speed = 6;
    } else if (value >= 13.9 && value < 17.2) {
        speed = 7;
    } else if (value >= 17.2 && value < 20.8) {
        speed = 8;
    } else if (value >= 20.8 && value < 24.5) {
        speed = 9;
    } else if (value >= 24.5 && value < 28.5) {
        speed = 10;
    } else if (value >= 28.5 && value < 32.7) {
        speed = 11;
    } else if (value >= 32.7 && value < 37) {
        speed = 12;
    } else if (value >= 37 && value < 42) {
        speed = 13;
    } else if (value >= 42 && value < 46) {
        speed = 14;
    } else if (value >= 46 && value < 52) {
        speed = 15;
    } else if (value >= 52 && value < 60) {
        speed = 16;
    } else if (value >= 60 && value < 61.2) {
        speed = 17;
    } else if (value >= 61.2) {
        speed = 18;
    }

    return speed;
};

/* 风向 */

/* northWind:'北风',
northeastWind:'东北风',
eastWind:'东风',
southeastWind:'东南风',
southWind:'南风',
southwestWind:'西南风',
weatWind:'西风',
northwestWind:'西北风', */
export const windDirectionControl = function (value) {
    let direction;

    if (value == 0 || value == 360) {
        direction = i18n.t("weatherStation.northWind"); // 北风
    } else if (value > 0 && value < 90) {
        direction = i18n.t("weatherStation.northeastWind"); // 东北风
    } else if (value == 90) {
        direction = i18n.t("weatherStation.eastWind"); // 东风
    } else if (value > 90 && value < 180) {
        direction = i18n.t("weatherStation.southeastWind"); // 东南风
    } else if (value == 180) {
        direction = i18n.t("weatherStation.southWind"); // 南风
    } else if (value > 180 && value < 270) {
        direction = i18n.t("weatherStation.southwestWind"); // 西南风
    } else if (value == 270) {
        direction = i18n.t("weatherStation.weatWind"); // 西风
    } else if (value > 270 && value < 360) {
        direction = i18n.t("weatherStation.northwestWind"); // 西北风
    }

    return direction;
};

/* 任务状态 */
export const taskStatus = [
    {
        label: "unpublished",
        name: "未发布",
        value: 1,
        number: 0,
    },
    {
        label: "published",
        name: "已发布",
        value: 2,
        number: 0,
    },
    {
        label: "inExecution",
        name: "执行中",
        value: 3,
        number: 0,
    },
    {
        label: "completed",
        name: "已完成",
        value: 4,
        number: 0,
    },
    {
        label: "deleted",
        name: "已删除",
        value: 5,
        number: 0,
    },
];

/* 任务类型 */
export const taskType = [
    {
        label: "public.pointReconnaissance",
        name: "点侦察",
        value: 1,
        path: "/task-manage/spot",
    },
    {
        label: "public.regionalReconnaissance",
        name: "区域侦察",
        value: 2,
        path: "/task-manage/area",
    },
    {
        label: "public.orthophoto",
        name: "正射影像",
        value: 3,
        path: "/task-manage/orthophoto",
    },
    {
        label: "public.tiltPhotography",
        name: "倾斜摄影",
        value: 4,
        path: "/task-manage/oblique-photography",
    },
    {
        label: "public.logisticsTransportation",
        name: "物流运输",
        value: 5,
        path: "/task-manage/logistics",
    },
];

/* 任务类型常量 */
export const taskTypeConst = {
    SPOT: 1, // 点侦察
    AREA: 2, // 区域侦察
    ORTHOPHOTO: 3, // 正射影像
    OBLIQUE: 4, // 倾斜摄影
    LOGISTICS: 5, // 物流运输
};

/* 任务性质 */
export const taskNature = [
    {
        label: "taskManage.public",
        name: "公开",
        value: 1,
    },
    {
        label: "taskManage.personal",
        name: "个人",
        value: 2,
    },
    {
        label: "taskManage.personalAndShared",
        name: "个人及共享",
        value: 3,
    },
    {
        label: "taskManage.customize",
        name: "自定义",
        value: 4,
    },
];

/* 审批状态 */
export const approvalStatus = [
    {
        label: "taskManage.pending",
        name: "待审批",
        value: 2,
        number: 0,
    },
    {
        label: "taskManage.timeoutNotApproved",
        name: "超时未审批",
        value: 1,
        number: 0,
    },
    {
        label: "taskManage.didNotPass",
        name: "未通过",
        value: 3,
        number: 0,
    },
    {
        label: "taskManage.approved",
        name: "已审批",
        value: 4,
        number: 0,
    },
];

/* 消息等级 */
export const messageLevel = [
    {
        label: "tta.urgent",
        name: "紧急",
        value: "0",
    },
    {
        label: "tta.high",
        name: "高",
        value: "1",
    },
    {
        label: "tta.medium",
        name: "中",
        value: "2",
    },
    {
        label: "tta.low",
        name: "低",
        value: "3",
    },
];

/**
 * 无人机飞行状态
 * @param {number} uavFlyState
 * @param {number} conn
 * @returns {string}
 */
export function uavMode(uavFlyState, conn) {
    let mode = "";
    // 未连接直接返回
    if (conn == -3) {
        return mode;
    }
    switch (uavFlyState * 1) {
        case 20:
            mode = i18n.t("uavMode.UM1"); // 起飞模式未飞行
            break;
        case 21:
            mode = i18n.t("uavMode.UM2"); // 执行起飞失败
            break;
        case 22:
            mode = i18n.t("uavMode.UM3"); // 暂停起飞
            break;
        case 23:
            mode = i18n.t("uavMode.UM4"); // 起飞中
            break;
        case 29:
            mode = i18n.t("uavMode.UM5"); // 起飞完成
            break;
        case 30:
            mode = i18n.t("uavMode.UM6"); // 降落模式未飞行
            break;
        case 31:
            mode = i18n.t("uavMode.UM7"); // 执行降落失败
            break;
        case 32:
            mode = i18n.t("uavMode.UM8"); // 暂停降落
            break;
        case 34:
            mode = i18n.t("uavMode.UM9"); // 降落中
            break;
        case 38:
            mode = i18n.t("uavMode.UM10"); // 紧急状态降落中
            break;
        case 39:
            mode = i18n.t("uavMode.UM11"); // 降落完成
            break;
        case 51:
            mode = i18n.t("uavMode.UM12"); // 执行返航失败
            break;
        case 52:
            mode = i18n.t("uavMode.UM13"); // 暂停返航
            break;
        case 54:
            mode = i18n.t("uavMode.UM14"); // 返航降落中
            break;
        case 55:
            mode = i18n.t("uavMode.UM15"); // 返航中
            break;
        case 57:
            mode = i18n.t("uavMode.UM16"); // 返航到起飞点
            break;
        case 59:
            mode = i18n.t("uavMode.UM17"); // 返航完成
            break;
        case 61:
            mode = i18n.t("uavMode.UM18"); // 执行原路返航失败
            break;
        case 62:
            mode = i18n.t("uavMode.UM19"); //暂停原路返航
            break;
        case 64:
            mode = i18n.t("uavMode.UM20"); // 原路返航降落中
            break;
        case 65:
            mode = i18n.t("uavMode.UM21"); // 原路返航中
            break;
        case 67:
            mode = i18n.t("uavMode.UM22"); // 原路返航到起飞点
            break;
        case 69:
            mode = i18n.t("uavMode.UM23"); // 原路返航完成
            break;
        case 71:
            mode = i18n.t("uavMode.UM24"); // 执行归航失败
            break;
        case 72:
            mode = i18n.t("uavMode.UM25"); // 暂停归航
            break;
        case 74:
            mode = i18n.t("uavMode.UM26"); // 归航降落中
            break;
        case 75:
            mode = i18n.t("uavMode.UM27"); // 归航中
            break;
        case 77:
            mode = i18n.t("uavMode.UM28"); // 飞到归航点
            break;
        case 79:
            mode = i18n.t("uavMode.UM29"); // 归航完成
            break;
        case 80:
            mode = i18n.t("uavMode.UM30"); // 指点未飞行
            break;
        case 81:
            mode = i18n.t("uavMode.UM31"); // 执行指点飞行失败
            break;
        case 82:
            mode = i18n.t("uavMode.UM32"); // 暂停指点飞行
            break;
        case 83:
            mode = i18n.t("uavMode.UM33"); // 指点飞行起飞中
            break;
        case 84:
            mode = i18n.t("uavMode.UM34"); // 指点飞行降落中
            break;
        case 85:
            mode = i18n.t("uavMode.UM35"); // 指点飞行中
            break;
        case 86:
            mode = i18n.t("uavMode.UM36"); // 悬停过程
            break;
        case 87:
            mode = i18n.t("uavMode.UM37"); // 飞到指定点
            break;
        case 88:
            mode = i18n.t("uavMode.UM38"); // 执行预设动作
            break;
        case 89:
            mode = i18n.t("uavMode.UM39"); // 指点飞行完成
            break;
        case 90:
            mode = i18n.t("uavMode.UM40"); // 环绕未飞行
            break;
        case 91:
            mode = i18n.t("uavMode.UM41"); // 执行环绕飞行失败
            break;
        case 92:
            mode = i18n.t("uavMode.UM42"); // 暂停环绕飞行
            break;
        case 93:
            mode = i18n.t("uavMode.UM43"); // 环绕飞行起飞中
            break;
        case 94:
            mode = i18n.t("uavMode.UM44"); // 环绕飞行降落中
            break;
        case 95:
            mode = i18n.t("uavMode.UM45"); // 环绕飞行中
            break;
        case 96:
            mode = i18n.t("uavMode.UM46"); // 悬停过程
            break;
        case 97:
            mode = i18n.t("uavMode.UM47"); // 飞到环绕点
            break;
        case 98:
            mode = i18n.t("uavMode.UM48"); // 执行预设动作
            break;
        case 99:
            mode = i18n.t("uavMode.UM49"); // 环绕飞行完成
            break;
        case 100:
            mode = i18n.t("uavMode.UM50"); // 增稳模式未飞行
            break;
        case 101:
            mode = i18n.t("uavMode.UM51"); // 解锁增稳模式失败
            break;
        case 105:
            mode = i18n.t("uavMode.UM52"); // 增稳模式遥控器控制
            break;
        case 110:
            mode = i18n.t("uavMode.UM53"); // 定高模式未飞行
            break;
        case 111:
            mode = i18n.t("uavMode.UM54"); // 解锁定高模式失败
            break;
        case 115:
            mode = i18n.t("uavMode.UM55"); // 定高模式遥控器控制
            break;
        case 120:
            mode = i18n.t("uavMode.UM56"); // 定点模式未飞行
            break;
        case 121:
            mode = i18n.t("uavMode.UM57"); // 定点模式失败
            break;
        case 125:
            mode = i18n.t("uavMode.UM58"); // 定点模式遥控器控制
            break;
        case 127:
            mode = i18n.t("uavMode.UM59"); // 定点悬停
            break;
        case 130:
            mode = i18n.t("uavMode.UM60"); // 自动航线未飞行
            break;
        case 131:
            mode = i18n.t("uavMode.UM61"); // 执行自动航线失败
            break;
        case 132:
            mode = i18n.t("uavMode.UM62"); // 暂停自动航线
            break;
        case 133:
            mode = i18n.t("uavMode.UM63"); // 自动航线起飞中
            break;
        case 134:
            mode = i18n.t("uavMode.UM64"); // 自动航线降落中
            break;
        case 135:
            mode = i18n.t("uavMode.UM65"); // 自动航线中
            break;
        case 136:
            mode = i18n.t("uavMode.UM66"); // 悬停过程
            break;
        case 137:
            mode = i18n.t("uavMode.UM67"); // 飞到航点
            break;
        case 138:
            mode = i18n.t("uavMode.UM68"); // 执行预设动作
            break;
        case 139:
            mode = i18n.t("uavMode.UM69"); // 自动航线完成
            break;
        case 140:
            mode = i18n.t("uavMode.UM70"); // "执行AB点航线未飞行";
            break;
        case 141:
            mode = i18n.t("uavMode.UM71"); // "执行AB点航线失败";
            break;
        case 142:
            mode = i18n.t("uavMode.UM72"); // "暂停AB点航线航线";
            break;
        case 143:
            mode = i18n.t("uavMode.UM73"); // "AB点航线:A->B";
            break;
        case 144:
            mode = i18n.t("uavMode.UM74"); // "AB点航线:B->B";
            break;
        case 145:
            mode = i18n.t("uavMode.UM75"); // "AB点航线:B->A";
            break;
        case 146:
            mode = i18n.t("uavMode.UM76"); // "AB点航线:A->A";
            break;
        case 147:
            mode = i18n.t("uavMode.UM77"); // "AB点航线变更";
            break;
        case 148:
            mode = i18n.t("uavMode.UM78"); // "AB点航线手动避障";
            break;
        case 149:
            mode = i18n.t("uavMode.UM79"); // "AB点航线执行断点";
            break;
        default:
            mode = "";
            break;
    }

    return mode;
}

/**
 * 无人机飞行模式
 * @param {number} flightMode
 * @returns {string}
 */
export function uavFlightMode(flightMode) {
    let mode = "";
    switch (flightMode * 1) {
        case 1:
            mode = i18n.t("flightMode.FM1"); // 未飞行
            break;
        case 2:
            mode = i18n.t("flightMode.FM2"); // 起飞模式
            break;
        case 3:
            mode = i18n.t("flightMode.FM3"); // 降落模式
            break;
        case 5:
            mode = i18n.t("flightMode.FM4"); // 返航模式
            break;
        case 6:
            mode = i18n.t("flightMode.FM5"); // 原路返航模式
            break;
        case 7:
            mode = i18n.t("flightMode.FM6"); // 归航模式
            break;
        case 8:
            mode = i18n.t("flightMode.FM7"); // 指点模式
            break;
        case 9:
            mode = i18n.t("flightMode.FM8"); // 环绕模式
            break;
        case 10:
            mode = i18n.t("flightMode.FM9"); // 增稳模式
            break;
        case 11:
            mode = i18n.t("flightMode.FM10"); // 定高模式
            break;
        case 12:
            mode = i18n.t("flightMode.FM11"); // 定点模式
            break;
        case 13:
            mode = i18n.t("flightMode.FM12"); // 自动航线
            break;
        case 14:
            mode = i18n.t("flightMode.FM13"); // AB点模式
            break;
        default:
            mode = "";
            break;
    }
    return mode;
}

/**
 * 电池类型
 * @param {number} voltages
 * @param {number} type
 * @returns {string}
 */
export function batteryType(voltages, type) {
    if (!voltages) {
        return undefined;
    }
    let _type_ = "";
    const S = voltages.length + "s";
    switch (type) {
        case 0:
            _type_ = i18n.t("public.unknown"); // "未知";
            break;
        case 1:
            _type_ = "LICO2 " + S;
            break;
        case 2:
            _type_ = "LIB " + S;
            break;
        case 3:
            _type_ = "PLB " + S;
            break;
        case 4:
            _type_ = "NiCoMn " + S;
            break;
        case 5:
            _type_ = "NIH " + S;
            break;
        case 6:
            _type_ = "LIFE " + S;
            break;
        case 7:
            _type_ = "18650 " + S;
            break;
        case 8:
            _type_ = "26650 " + S;
            break;
        case 9:
            _type_ = "ENUM_END " + S;
            break;
        default:
            break;
    }
    return _type_;
}

/**
 * rtk定位类型
 * @param {number} type
 * @returns {string}
 */
export function rtkPositionType(type) {
    let _type_ = "";
    if (type == 0) {
        _type_ = i18n.t("rtk.rtk1"); // '无定位'
    } else if (type == 1) {
        _type_ = i18n.t("rtk.rtk2"); // "GPS定位差";
    } else if (type == 2) {
        _type_ = i18n.t("rtk.rtk3"); // "RTK单点解定位";
    } else if (type == 3) {
        _type_ = i18n.t("rtk.rtk4"); // "RTK差分解定位";
    } else if (type == 4) {
        _type_ = i18n.t("rtk.rtk5"); // "RTK浮点解定位";
    } else if (type == 5) {
        _type_ = i18n.t("rtk.rtk6"); // "RTK固定解定位";
    } else if (type == 6) {
        _type_ = i18n.t("rtk.rtk7"); // "GPS定位";
    }
    return _type_;
}

/**
 * rtk类型
 * @param {number} type
 * @returns {string}
 */
export function getRtkType(type) {
    let _type = "";
    if (type === 0) {
        _type = '标准网络'
    } else if (type == 1) {
        _type = '本地网络'
    } else if (type == 2) {
        _type = '其他网络'
    } else if (type == 3) {
        _type = '自定义网络'
    } else if (type == 5) {
        _type = '不使用'
    }
    return _type;
}

/**
 * rtk是否在线
 * @param {number} type
 * @returns {Boolean}
 */
export function isRtkOnline(type) {
    if (type == 2 || type == 3 || type == 4 || type == 5) {
        return true
    }
    return false;
}

/* 
垂起固定翼转弯模式
*/
export const TURN_MODE_VTL = {
    ARRIVE: 0,// 到达点
    TURNING: 1,// 转弯点
}
export const turnModeVtl = [
    {
        label: '到达点',
        value: TURN_MODE_VTL.ARRIVE
    }, {
        label: '转弯点',
        value: TURN_MODE_VTL.TURNING
    }
]

/* 
垂起固定翼转弯方向
*/
export const TURNING_DIRECTION_VTL = {
    CLOCKWISE: 0,// 顺时针
    COUNTERCLOCKWISE: 1,// 逆时针
}
export const turningDirectionVtl = [
    {
        label: '顺时针',
        value: TURNING_DIRECTION_VTL.CLOCKWISE
    }, {
        label: '逆时针',
        value: TURNING_DIRECTION_VTL.COUNTERCLOCKWISE
    }
]


/* 
固件类型
*/
export const FIRMWARE_TYPE = {
    FC: 1, // 飞控
    SH: 3, // SH
    TC: 4, // TC
    RTK: 6, // RTK
    GB: 51, // 云台
    HOK: 61, // 抛投器
    SPK: 143, // 喊话器
    GW: 253, // 网关
}
export const firmwareTypeLabels = {
    [FIRMWARE_TYPE.FC]: '飞控', // 飞控
    [FIRMWARE_TYPE.SH]: 'SH', // SH
    [FIRMWARE_TYPE.TC]: 'TC', // TC
    [FIRMWARE_TYPE.RTK]: 'RTK', // RTK
    [FIRMWARE_TYPE.GB]: '云台', // 云台
    [FIRMWARE_TYPE.HOK]: '抛投器', // 抛投器
    [FIRMWARE_TYPE.SPK]: '喊话器', // 喊话器
    [FIRMWARE_TYPE.GW]: '网关', // 网关
}


/* 
考试科目类型
*/
export const EXAMINATION_SUBJECTS = {
    PRE_PLANNING: 0, // 预规划
    RE_PLANNING: 1, // 重规划
    EMERGENCY_RETURN: 2, // 应急返航
}
export const examinationSubjects = [
    {
        label: '预规划',
        value: EXAMINATION_SUBJECTS.PRE_PLANNING
    },
    {
        label: '重规划',
        value: EXAMINATION_SUBJECTS.RE_PLANNING
    },
    {
        label: '应急返航',
        value: EXAMINATION_SUBJECTS.EMERGENCY_RETURN
    },
]
export const examinationSubjectsMap = {
    [EXAMINATION_SUBJECTS.PRE_PLANNING]: '预规划',
    [EXAMINATION_SUBJECTS.RE_PLANNING]: '重规划',
    [EXAMINATION_SUBJECTS.EMERGENCY_RETURN]: '应急返航',
}
/* 
考试状态
*/
export const EXAM_STATUS = {
    NOT_REGISTERED: 0, // 未报名
    PARTICIPATED: 1, // 已参加
    WAITING_START: 2, // 等待开始
    DURING_EXAM: 3, // 考试中
    COMPLETED: 4, // 已完成
    ABSENCE: 5, // 缺考
    AI_SCORING: 6, // AI评分中
}
export const examStatus = [
    {
        label: '未报名',
        value: EXAM_STATUS.NOT_REGISTERED
    },
    {
        label: '已参加',
        value: EXAM_STATUS.PARTICIPATED
    },
    {
        label: '等待开始',
        value: EXAM_STATUS.WAITING_START
    },
    {
        label: '考试中',
        value: EXAM_STATUS.DURING_EXAM
    },
    {
        label: '已完成',
        value: EXAM_STATUS.COMPLETED
    },
    {
        label: '缺考',
        value: EXAM_STATUS.ABSENCE
    },
    {
        label: 'AI评分中',
        value: EXAM_STATUS.AI_SCORING
    },
]

export const examStatusMap = {
    [EXAM_STATUS.NOT_REGISTERED]: '未报名',
    [EXAM_STATUS.PARTICIPATED]: '已参加',
    [EXAM_STATUS.WAITING_START]: '等待开始',
    [EXAM_STATUS.DURING_EXAM]: '考试中',
    [EXAM_STATUS.COMPLETED]: '已完成',
    [EXAM_STATUS.ABSENCE]: '缺考',
    [EXAM_STATUS.AI_SCORING]: 'AI评分中',
}